<script setup>
const props = defineProps({
    icon: String,
    title: String,
    subtitle: String
})
</script>

<template>
    <div class="card">
        <img class="icon" :src="props.icon" alt="">

        <div class="text">
            <h3 class="title">{{ $t(props.title) }}</h3>
            <p class="subtitle">{{ $t(props.subtitle) }}</p>
        </div>
    </div>
</template>

<style scoped>
.card {
    border: 2px solid #E5F2FF;
    background-color: rgba(125, 188, 255, 0.1);
    padding: 20px;

    height: 273px;
}

.text {
    margin-top: 54px;
}

.icon {
    width: 36px;
    height: 36px;
}

.title {
    margin-bottom: 10px;

    font-size: 25px;
    font-weight: 600;
    line-height: 100%;
}

.subtitle {
    margin: 0;
    font-weight: 400;
    font-size: 20px;

    line-height: 110%;
}

@media screen and (max-width: 1280px) {
    .card {
        min-width: 305px;
    }
}
</style>